import { Component, OnInit, Input, ViewChild, OnChanges } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { RequestEndorseSubject } from '../shared/request-endorse-subject.model';

@Component({
  selector: 'app-endorse-detail-subject',
  templateUrl: './endorse-detail-subject.component.html',
  styleUrls: ['./endorse-detail-subject.component.scss']
})
export class EndorseDetailSubjectComponent implements OnInit, OnChanges {
selected = 'P';
displayedColumns: string[] = ['semestre', 'materia', 'consecutivo',
  'nota', 'maetriaHomologada', 'fecha', 'evaluador', 'estadoMateria', 'estado'];
dataSource: MatTableDataSource<RequestEndorseSubject>;
@Input() requets: RequestEndorseSubject[];


@ViewChild(MatPaginator) paginator: MatPaginator;
@ViewChild(MatSort) sort: MatSort;

constructor( ) {
  this.setTable();
}

ngOnInit() {
  this.setTable();
}
ngOnChanges() {
  this.setTable();
}


private setTable() {
  this.dataSource = new MatTableDataSource(this.requets);
  this.dataSource.paginator = this.paginator;
  this.dataSource.sort = this.sort;
  if (this.dataSource.paginator) {
    this.dataSource.paginator.firstPage();
  }
 }

 setAvalField(state) {
  this.requets = this.requets.map(
    (subject) => {
        subject.aval =  state;
        return subject;
    });
    this.setTable();
 }

}
